import { render, staticRenderFns } from "./pingpong.vue?vue&type=template&id=94db6de2&scoped=true&"
import script from "./pingpong.vue?vue&type=script&lang=tsx&"
export * from "./pingpong.vue?vue&type=script&lang=tsx&"
import style0 from "./pingpong.vue?vue&type=style&index=0&id=94db6de2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94db6de2",
  null
  
)

export default component.exports